
<!-- ------------------------------------------ creation & Edit Industry Sectors Feilds => Eng Ahmed Abdelhameed ALi ------------------------------------------ -->

<div class="modal-header">
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="addIndustrySectorFeild" (ngSubmit)="submit()">
        <div class="form-group">
          <label class="d-flex w-100 justify-content-center"><h5 class="text-center">{{industrySector.nameInEnglish}}</h5></label>     
        </div>
        <div class="form-group">
            <label for="validationCustom01">{{'GENERAL.ENGLISH_NAME' | translate}}</label>
            <input type="text" class="form-control" formControlName="nameInEnglish" id="validationCustom01"
            [ngClass]="{'is-valid':getAddIndustrySectorFeilds.nameInEnglish.dirty,'is-invalid':getAddIndustrySectorFeilds.nameInEnglish.invalid}">
        </div>
        <div class="form-group">
            <label for="validationCustom02">{{'GENERAL.ARABIC_NAME' | translate}}</label>
            <input type="text" class="form-control" formControlName="nameInArabic" id="validationCustom02"
            [ngClass]="{'is-valid':getAddIndustrySectorFeilds.nameInArabic.dirty,'is-invalid':getAddIndustrySectorFeilds.nameInArabic.invalid}">
        </div>
        <div class="form-group">
          <label for="validationCustom03">IAF Code</label>
          <input type="text" class="form-control" formControlName="iafCode_22" id="validationCustom03"
          [ngClass]="{'is-valid':getAddIndustrySectorFeilds.iafCode_22.dirty,'is-invalid':getAddIndustrySectorFeilds.iafCode_22.invalid}">
      </div>
        <div class="modal-footer d-flex justify-content-center">
            <button type="submit" class="btn btn-primary">save</button>
          </div>
    </form>
  </div>
  <!-- <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close('Close click')">Close</button>
  </div> -->